import { type Connection, PublicKey } from '@solana/web3.js'

// Minimum SOL required for gas + rent (in lamports)
const MIN_SOL_FOR_GAS = 0.005 * 1e9 // 0.005 SOL - enough for gas + token account rent

/**
 * TEMPORARY: Auto-request gas from faucet if user doesn't have enough
 * TODO: Remove this once Alchemy fixes their gasless sponsorship API
 * and re-enable sponsored transactions
 */
export async function ensureGasBalance(connection: Connection, userAddress: string): Promise<void> {
	const pubkey = new PublicKey(userAddress)
	const balance = await connection.getBalance(pubkey, 'confirmed')

	if (balance < MIN_SOL_FOR_GAS) {
		const response = await fetch('/api/faucet', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ address: userAddress }),
		})

		const result = await response.json()

		if (!response.ok) {
			throw new Error(`Failed to get gas: ${result.error || 'Unknown error'}`)
		}

		if (result.signature) {
			for (let i = 0; i < 15; i++) {
				await new Promise(resolve => setTimeout(resolve, 500))
				const newBalance = await connection.getBalance(pubkey, 'confirmed')
				if (newBalance >= MIN_SOL_FOR_GAS) {
					return
				}
			}
			// Continue anyway - tx might still work if faucet tx is pending
			console.warn('[ensureGasBalance] Timeout waiting for gas, continuing anyway...')
		}
	} else {
	}
}
